<div class="places-text font-size-14 font-weight-bold mb-3" [ngClass]="{'marginb-100' : areDetailsLoaded}">{{ getTitle() }}</div>

<div class="cv-health-report-content">
    <div *ngIf="areDetailsLoaded" class="cv-loader-container">
        <cv-loader [loaderType]="'auto'" [size]="'medium'" [overlay]="false" [isFullScreen]="false"></cv-loader>
    </div>

    <div *ngIf="!areDetailsLoaded && endDate">
        <div class="d-flex flex-row mb-2" *ngFor="let reward of gameRewards?.slice(0, 5); let i = index">
            <!-- Levels -->
            <div [ngSwitch]="game?.GameType" class="d-flex col-7 px-0">
                <ng-container *ngSwitchCase="1">
                    <span *ngIf="reward.name=='REWARDS_PER_METRICS'">
                        {{ getLocalizedMultiplierMadnessText(true) }}
                    </span>
                    <span *ngIf="reward.name=='MAX_PAYOUT_POSSIBLE'">
                        {{ getLocalizedMultiplierMadnessText(false) }}
                    </span>
                </ng-container>
                <ng-container *ngSwitchCase="2">
                    <div class="topDogRankIcon topDogRank{{i+1}}"></div>
                    <span class="places-text align-self-center mx-2">{{ getLocalizedTierText(i+1) }}</span>
                </ng-container>
                <ng-container *ngSwitchCase="3">
                    <div class="bullseyeTargetIcon tier{{i+1}}"></div>
                    <span class="places-text align-self-center mx-2">{{ getRangeText(reward) }}</span>
                    <span class="colorBullseye align-self-center">{{ getExtraDetailsText(reward.name) }}</span>
                </ng-container>
                <ng-container *ngSwitchCase="5">
                    <div class="milestoneTargetIcon" [ngStyle]="getMilestoneImage(i+1)"></div>
                    <span class="places-text align-self-center mx-2">{{ getRangeText(reward) }}</span>
                    <span class="colorMilestone align-self-center">{{ getExtraDetailsText(reward.name) }}</span>
                </ng-container>
                <ng-container *ngSwitchCase="6">
                    <span>{{ getConnectGamesText(true) }}</span>
                </ng-container>
                <ng-container *ngSwitchCase="7">
                    <span>{{ getConnectGamesText(false) }}</span>
                </ng-container>
                <ng-container *ngSwitchCase="8">
                    <div class="topDogRankIcon topDogRank{{i+1}}"></div>
                    <span class="places-text align-self-center mx-2">{{ getLocalizedTierText(i+1) }}</span>
                </ng-container>
                <ng-container *ngSwitchCase="9">
                    <ng-container *ngIf="i < 5">
                        <span>{{ getRafflePrizeText(i+1) }}</span>
                    </ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="10">
                    <span>{{ getBracketRoundName(i + 1) }}</span>
                </ng-container>
            </div>

            <!-- Rewards -->
            <div class="d-flex col-5 align-items-center pl-0" [ngClass]="{'justify-content-between': hasBadges}"
                 *ngIf="reward != null && !reward.customReward; else customReward">
                <div class="rewards col-4 pl-0" [title]="reward.coins ?? 0">
                    <span class="align-text-bottom">
                        <svg class="icon-16 fill-midas">
                            <use href="../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use>
                        </svg>
                    </span>
                    <span class="ml-1 font-size-14 color-whaleTail font-weight-bold">{{ reward.coins ?? 0 }}</span>
                </div>
                <div class="rewards col-4 pl-0" [title]="reward.xp ?? 0">
                    <span class="align-text-bottom">
                        <svg class="icon-16 fill-dimetapp">
                            <use href="../../App_Themes/clearview-default/icons/utility/xp.svg#xp"></use>
                        </svg>
                    </span>
                    <span class="ml-1 font-size-14 color-whaleTail font-weight-bold">{{ reward.xp ?? 0 }}</span>
                </div>
                <div class="rewards col-4 pl-0" *ngIf="hasBadges">
                    <span class="align-text-bottom">
                        <svg class="icon-16 fill-badge">
                            <use href="../../../App_Themes/clearview-default/icons/utility/badge.svg#badge"></use>
                        </svg>
                    </span>
                    <span class="ml-1 font-size-14 color-whaleTail font-weight-bold">{{ reward.badges ? 1 : 0 }}</span>
                </div>
            </div>
            <ng-template #customReward>
                <span *ngIf="reward != null" class="ml-0 font-size-14 color-whaleTail font-weight-bold rewards" [title]="reward.customReward">{{ reward.customReward }}</span>
            </ng-template>
        </div>

        <ng-container *ngIf="game?.GameType === 9 && gameRewards != null && gameRewards.length > 5">
            <span class="more-text" cvLocalizedText langSection="Games_History" langKey="More_Prizes"
                  #rafflePopover="ngbPopover"
                  [ngbPopover]="popoverTemplate"
                  popoverClass="rafflePopContainer"
                  [autoClose]="'outside'"
                  (mouseenter)="openPopover(rafflePopover)"
                  (mouseleave)="closePopover();"
                  triggers="manual"
                  placement="right">
                More Prizes
            </span>
        </ng-container>
    </div>

</div>

<ng-template #popoverTemplate>
    <div (mouseenter)="cancelTimeout();"
         (mouseleave)="closePopover();"
         (click)="$event.stopPropagation()">

        <div class="d-flex flex-row col-12 mb-2 px-0" *ngFor="let reward of gameRewards?.slice(5); let i = index">
            <div class="d-flex col-4 px-0">
                <span>{{ getRafflePrizeText(i + 6) }}</span>
            </div>

            <div class="d-flex col-8 align-items-center pl-0" *ngIf="!reward.customReward; else custom">
                <div class="rewards col-6 pl-0">
                    <span class="align-text-bottom">
                        <svg class="icon-16 fill-midas">
                            <use href="../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use>
                        </svg>
                    </span>
                    <span class="ml-1 font-size-14 color-whaleTail font-weight-bold">{{ reward.coins ?? 0 }}</span>
                </div>
                <div class="rewards col-6 pl-0">
                    <span class="align-text-bottom">
                        <svg class="icon-16 fill-dimetapp">
                            <use href="../../App_Themes/clearview-default/icons/utility/xp.svg#xp"></use>
                        </svg>
                    </span>
                    <span class="ml-1 font-size-14 color-whaleTail font-weight-bold">{{ reward.xp ?? 0 }}</span>
                </div>
            </div>
            <ng-template #custom>
                <span class="ml-0 font-size-14 color-whaleTail font-weight-bold rewards">{{ reward.customReward }}</span>
            </ng-template>
        </div>
    </div>
</ng-template>
